// extracted by mini-css-extract-plugin
export default {"button":"style_button__HRfp0","button__icon":"style_button__icon__txWiP","button__text":"style_button__text__OKraj"};